import { render } from "./App.vue?vue&type=template&id=6a967a19"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
script.render = render

export default script